import Config from '#/config'
import i18n from '#/locales'
import {
  getPageInfo,
  getTeamInfo,
  getUserInfo,
} from '@/libvue/plugins/statistics/baseStats'

import { Murdock } from '@/murdock/browser'

const murdockService = new Murdock({
  host: Config.apiHost() ? Config.apiHost() : window.location.hostname,
  basePath: 'api/v2/stats',
  protocol: Config.API().use_ssl ? 'https' : 'http',
  requestType: 'beaconAPI',
})
export const rcPageStats = {
  install(app, options) {
    const router = options.router
    const state = options.stores.state

    murdockService.initAutoTracking()
    murdockService.on('recordEvents', (record) => {
      if (window.dataLayerQueue !== undefined) {
        record.events.forEach((e) => {
          if (e.event_type === 'pageview') {
            window.dataLayerQueue.push({
              ...e,
              event: 'pageView',
              app: {
                name: Config.decodedHost,
              },
              page: {
                ...e.page,
                language: i18n.locale,
                age_group_uid: state.auth.user.team_age_groups || '',
              },
            })
          }
        })
      }
    })

    router.afterEach((to, from) => {
      setTimeout(() => {
        const payload = formatPayload(to, state)
        postPageStats(to, payload)
      }, 3000)
    })
  },
}
function postPageStats(to, payload) {
  // Extend User & Team infos to ALl Murdock events
  murdockService.extendEvents(() => {
    return {
      user: payload.user_info ? payload.user_info : [],
      team: payload.team_info ? payload.team_info : [],
    }
  })
  // Send pageviews event
  murdockService.deferEvent(payload.event_type, payload)
}
function formatPayload(to, state) {
  const info = {}
  info.event_type = 'pageview'
  if ('user_uid' in state.auth.user && state.auth.user.user_uid)
    info.user_info = getUserInfo(state.auth.user)
  info.page_info = getPageInfo(to)
  if (Config.team.enabled) {
    info.team_info = getTeamInfo(state.auth.user)
  }

  return info
}
